// export DsfUpdateTime from "./updateTime.vue";
// export DsfCreateTime from "./createTime.vue";
// export DsfUpdateUserName from "./updateUserName.vue";
// export DsfCreateUserName from "./createUserName.vue";
// export DsfUpdateUserId from "./updateUserId.vue";
// export DsfCreateUserId from "./createUserId.vue";
// export DsfDeletedStatus from "./deletedStatus.vue";
// export DsfOrder from "./order.vue";
// export DsfDeptId from "./deptId.vue";

export const DsfUpdateTime = dsf.defineAsyncComponent("DsfUpdateTime", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./updateTime")
);
export const DsfCreateTime = dsf.defineAsyncComponent("DsfCreateTime", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./createTime")
);
export const DsfUpdateUserName = dsf.defineAsyncComponent("DsfUpdateUserName", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./updateUserName")
);
export const DsfCreateUserName = dsf.defineAsyncComponent("DsfCreateUserName", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./createUserName")
);
export const DsfOrder = dsf.defineAsyncComponent("DsfOrder", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./order")
);

export const DsfUpdateUserId = dsf.defineAsyncComponent("DsfUpdateUserId", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./updateUserId")
);
export const DsfCreateUserId = dsf.defineAsyncComponent("DsfCreateUserId", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./createUserId")
);
export const DsfDeletedStatus = dsf.defineAsyncComponent("DsfDeletedStatus", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./deletedStatus")
);
export const DsfDeptId = dsf.defineAsyncComponent("DsfDeptId", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./deptId")
);
